/**
 * Blog post page
 */

import {useParams, Link} from 'react-router-dom';
import {LandingLayout} from '../../components/layout/LandingLayout';
import {Container} from '../../components/ui/Container';
import {Section} from '../../components/ui/Section';
import {ROUTES} from '../../config/constants';

export function BlogPostPage() {
  const {slug} = useParams<{slug: string}>();

  return (
    <LandingLayout>
      <Section padding="lg" background="white" className="pt-32 bg-background dark:bg-[#1E1E1E]">
        <Container className="max-w-3xl">
          <Link
            to={ROUTES.BLOG}
            className="text-accent dark:text-orange-500 hover:underline mb-8 inline-block"
          >
            ← Back to Blog
          </Link>

          <article className="prose prose-lg max-w-none">
            <h1 className="text-4xl sm:text-5xl font-heading font-bold text-textPrimary dark:text-[#CCCCCC] mb-4">
              Blog Post: {slug}
            </h1>
            <div className="flex items-center gap-4 text-sm text-textTertiary dark:text-[#6A6A6A] mb-8">
              <span>By Author Name</span>
              <span>•</span>
              <span>{new Date().toLocaleDateString()}</span>
            </div>
            <div className="text-textSecondary dark:text-[#858585] leading-relaxed space-y-4">
              <p>
                This is a placeholder blog post. In a real implementation, you would fetch
                the blog post content based on the slug parameter and display it here.
              </p>
              <p>
                You can integrate with a CMS, markdown files, or a database to store and
                retrieve blog post content.
              </p>
            </div>
          </article>
        </Container>
      </Section>
    </LandingLayout>
  );
}

